module.exports = __webpack_public_path__ + "Simple-Line-Icons.73a932562a1e31470346.svg";


//////////////////
// WEBPACK FOOTER
// D:/Works/Safetyminder/Safetyminder/Admin/src/assets/fonts/Simple-Line-Icons.svg?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.svg?v=2.4.0
// module chunks = styles